<div class="lead-page" *ngIf="partner">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>{{ partner.company_name }}</h2>
        <p>{{ partner.status_label }}<span *ngIf="partner.business_type_label"> · {{ partner.business_type_label }}</span></p>
      </div>
      <div class="lead-actions">
          <button
                  class="lead-btn-secondary"
                  *ngIf="canRevertToLead"
                  (click)="revertToLead()"
                  [disabled]="reverting">
              {{ reverting ? 'Reverting...' : 'Revert to Lead' }}
          </button>
        <button class="lead-btn-secondary" (click)="router.navigate(['admin/sales-installation-partners', partner.id, 'edit'])">Edit</button>
        <button class="lead-btn-muted" (click)="router.navigate(['admin/sales-installation-partners'])">Back to List</button>
      </div>
    </div>

    <div class="lead-section">
      <h4>Partner Details</h4>
      <div class="lead-summary-grid">
        <div class="lead-summary-item"><label>Contact Person</label><div>{{ partner.contact_person || '-' }}</div></div>
        <div class="lead-summary-item"><label>Mobile Number</label><div>{{ partner.mobile_number }}</div></div>
        <div class="lead-summary-item"><label>Alternate Mobile Number</label><div>{{ partner.alternate_mobile_number || '-' }}</div></div>
        <div class="lead-summary-item"><label>Email</label><div>{{ partner.email || '-' }}</div></div>
        <div class="lead-summary-item"><label>City</label><div>{{ partner.city || '-' }}</div></div>
        <div class="lead-summary-item"><label>State</label><div>{{ partner.state || '-' }}</div></div>
        <div class="lead-summary-item"><label>GST Number</label><div>{{ partner.gst_number || '-' }}</div></div>
        <div class="lead-summary-item"><label>Service Areas</label><div>{{ partner.service_areas || '-' }}</div></div>
        <div class="lead-summary-item" style="grid-column: 1 / -1;"><label>Address</label><div>{{ partner.address || '-' }}</div></div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Commercial Details</h4>
      <div class="lead-summary-grid">
        <div class="lead-summary-item"><label>Commission Type</label><div>{{ partner.default_commission_type_label || '-' }}</div></div>
        <div class="lead-summary-item"><label>Commission Value</label><div>{{ partner.default_commission_value || '-' }}</div></div>
        <div class="lead-summary-item"><label>Margin Percentage</label><div>{{ partner.default_margin_percentage || '-' }}</div></div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Visibility Stats</h4>
      <div class="lead-summary-grid">
        <div class="lead-summary-item"><label>Total Leads Referred</label><div>{{ partner.total_leads_referred || 0 }}</div></div>
        <div class="lead-summary-item"><label>Converted Organizations</label><div>{{ partner.converted_organizations || 0 }}</div></div>
        <div class="lead-summary-item"><label>Active Organizations</label><div>{{ partner.active_organizations || 0 }}</div></div>
        <div class="lead-summary-item"><label>Installations Handled</label><div>{{ partner.installations_handled || 0 }}</div></div>
        <div class="lead-summary-item"><label>Estimated Revenue via Partner</label><div>{{ partner.estimated_revenue_via_partner || 0 }}</div></div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Leads Referred</h4>
      <div class="lead-table-wrap">
        <table class="lead-table">
          <thead><tr><th>Lead ID</th><th>Customer</th><th>Contact</th><th>Mobile</th><th>Status</th></tr></thead>
          <tbody>
            <tr *ngIf="!partner.leads_referred?.length"><td colspan="5" class="lead-empty">No referred leads yet.</td></tr>
            <tr *ngFor="let lead of partner.leads_referred">
              <td>{{ lead.lead_id }}</td><td>{{ lead.customer_name }}</td><td>{{ lead.contact_person || '-' }}</td><td>{{ lead.phone_number }}</td><td>{{ lead.status_label }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="lead-section">
      <h4>Organizations Linked</h4>
      <div class="lead-table-wrap">
        <table class="lead-table">
          <thead><tr><th>Name</th><th>Customer Source</th><th>Installation By</th><th>Status</th></tr></thead>
          <tbody>
            <tr *ngIf="!partner.organizations_linked?.length"><td colspan="4" class="lead-empty">No organizations linked yet.</td></tr>
            <tr *ngFor="let organization of partner.organizations_linked">
              <td>{{ organization.name }}</td><td>{{ organization.customer_source_label || '-' }}</td><td>{{ organization.installation_by_label || '-' }}</td><td>{{ organization.is_active ? 'Active' : 'Inactive' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="lead-section">
      <h4>Notes</h4>
      <div class="lead-summary-item"><div>{{ partner.notes || '-' }}</div></div>
    </div>
  </div>
</div>
